import { AnimatePresence, domAnimation, LazyMotion, m } from 'framer-motion';
import { ExclamationCircle } from 'react-bootstrap-icons';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSFlexbox } from '@repo/sds/components/SDSFlexbox';
import { SDSIcon } from '@repo/sds/components/SDSIcon';
import { SDSText } from '@repo/sds/components/SDSText';

export interface SDSInputErrorMessageProps {
  errorMessage?: string;
  dataTestId?: string;
  id?: string;
}

export function SDSInputErrorMessage({
  errorMessage,
  dataTestId = DataTestIds.SDS.INPUT_ERROR,
  id,
}: SDSInputErrorMessageProps) {
  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        {errorMessage && (
          <m.div
            id={id}
            role="alert"
            data-testid={dataTestId}
            style={{ alignSelf: 'flex-start', contain: 'layout style' }}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <SDSFlexbox gap="no-design-4" alignItems="center">
              <SDSIcon icon={<ExclamationCircle />} color="alert" size="small" />
              <SDSText text={errorMessage} type="body-small" color="alert" />
            </SDSFlexbox>
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotion>
  );
}
